import React, { useContext, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import './HamburgerMenu.css';

function HamburgerMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const { isAuthenticated, user } = useContext(AuthContext); // Access user object from AuthContext

    const isAdmin = ['admin', 'superadmin'].includes(user?.role);
    const isDriver = user?.role === 'driver';
    const closeMenu = () => setIsOpen(false);

    return (
        <div className="hamburger-menu">
            <button type="button" className="hamburger-icon" onClick={() => setIsOpen(current => !current)} aria-label={isOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={isOpen}>
                {isOpen ? <FaTimes /> : <FaBars />}
            </button>
            {isOpen && (
                <nav className="mobile-nav" aria-label="Mobile navigation">
                    {isDriver ? <Link to="/driver-orders" onClick={closeMenu}>My dispatch</Link> : <>
                        <Link to="/" onClick={closeMenu}>Menu</Link>
                        <Link to="/about-us" onClick={closeMenu}>Our kitchen</Link>
                        <Link to="/contact-us" onClick={closeMenu}>Contact</Link>
                        {isAuthenticated && <Link to="/orders" onClick={closeMenu}>My orders</Link>}
                        {isAdmin && <Link to="/kitchen" onClick={closeMenu}>Operations</Link>}
                    </>}
                </nav>
            )}
        </div>
    );
}

export default HamburgerMenu;
